import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AuthService } from 'src/app/modules/login/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public activeLocationSignal = signal('');

  private dialog: MatDialog = inject(MatDialog);

  private _auth = inject(AuthService);

  constructor(private router: Router) {
    this.onNavClick(router.url);
  }

  /** Ask before logging out, then log out on confirm.
   *
   *  Lives here rather than in each layout component so the sidebar and the
   *  header behave identically — both are one-line calls to this. */
  public confirmLogout() {
    const modalRef = this.dialog.open(ModalComponent, {
      data: {
        heading: 'layout.logoutModalHeading',
        okButtonText: 'layout.logout',
        text: ['layout.logoutModalText'],
        showCancelBtn: true,
      },
    });

    modalRef.componentInstance.onSave.subscribe(() => {
      modalRef.close();
      this._auth.logout();
    });
  }

  /** Navigate to provided link, set active nav btn
   * @param path Button navigation path
   */
  public onNavClick(path?: string) {
    if (!path) path = this.router.url;
    let subPath = path.slice(1);

    if (subPath.indexOf('/') != -1) {
      subPath = subPath.slice(0, subPath.indexOf('/'));
    }
    this.router.navigate([path]);
    this.activeLocationSignal.update(() => {
      return '/' + subPath;
    });
  }
}
